/**
 * The PERFORMANCE vocabulary on the floor (AGENT_PRESENCE_SPEC.md) — the
 * same label-verb → act mapping the dashboard and Nova use, so an agent
 * "Checking inbox" holds the same envelope everywhere. Labels arrive
 * humanized from the API (agentWork events / presence.label).
 */

export type AgentAction =
  | 'replying'
  | 'inbox'
  | 'reading'
  | 'searching'
  | 'building'
  | 'writing'
  | 'thinking'
  | 'waking'
  | 'brewing'
  | 'idle'

const ACTION_BY_VERB: Record<string, AgentAction> = {
  browsing: 'reading',
  checking: 'inbox',
  consulting: 'thinking',
  creating: 'building',
  delegating: 'building',
  drafting: 'writing',
  importing: 'building',
  looking: 'searching',
  making: 'building',
  planning: 'thinking',
  preparing: 'building',
  reading: 'reading',
  replying: 'replying',
  researching: 'searching',
  running: 'building',
  searching: 'searching',
  sending: 'replying',
  starting: 'brewing',
  studying: 'reading',
  tidying: 'inbox',
  updating: 'building',
  waking: 'waking',
  working: 'building',
  writing: 'writing',
}

/** Which act a humanized work line calls for. Unknown verbs read as building. */
export function actionForLabel(label?: string | null): AgentAction {
  const text = (label ?? '').trim().toLowerCase()
  if (!text) return 'building'
  const mapped = ACTION_BY_VERB[text.split(/\s+/)[0]]
  if (mapped) return mapped
  if (text.includes('search')) return 'searching'
  return 'building'
}
